import { BackgroundSection } from "shared/components/BackgroundSection";
import Layout from "../../components/Layout";
import ProductComparison from "shared/components/ProductComparison";
import { Link } from "shared/components/Link";



export const Page = () => {
  return (
    <Layout>
      <div className="mt-5">
        <ProductComparison active={0} links={LINKS} features={FEATURES} products={PRODUCTS} setVersion={() => null} />
        <BackgroundSection />
      </div>
    </Layout>
  );
};




const LINKS = [
  { type: "href", href: "https://scada-npt-compact.ru/" },
  { type: "href", href: "https://scada-npt-expert.com/" },
  { type: "href", href: "https://scada-npt-expert.com/?plus=true" },
];
export const FEATURES = [
  {
    label: "Базовый пакет",
    description: `Поддержка протоколов: Modbus, IEC 60870-5-104 Client;\n
Архивирование: Postgres/SQLite;\n
Web-клиенты: Неограничено;\n
Desktop приложение: 1 рабочее место.`,
    values: ["до 100 устройств", "больше 100", "больше 100"],
  },
  {
    label: "Клиенты",
    items: [
      {
        label: "Desktop Application",
        description: "Desktop приложение (дополнительное рабочее место)",
        values: [false, true, true],
      },
      {
        label: "Multimonitor Desktop Application",
        description:
          "Возможность объединения нескольких экранов (4 и более) (для одного рабочего места)",
        values: [false, false, true],
      },
      {
        label: "Touch Panel Application",
        description:
          "Embedded версия для панелей с touch screen (для одной графической панели)",
        values: [true, false, true],
      },
      {
        label: "NPT Mobile",
        description:
          "Embedded версия для панелей с touch screen (для одной графической панели)",
        values: [true, true, true],
      },
    ],
  },
  {
    label: "Автоматизация и логическая обработка",
    items: [
      {
        label: "Report builder",
        description: "Конструктор отчетов",
        values: [true, true, true],
      },
      {
        label: "IEC 61131",
        description: "Свободно-программируемая логика МЭК 61131 ST и FBD",
        values: [true, true, true],
      },
      {
        label: "Cron tasks",
        description: "Периодические задачи/выполнение задач по расписанию",
        values: [true, true, true],
      },
      {
        label: "Switching plan editor",
        description: "Редактор автоматических и автоматизированных бланков переключений",
        values: [true, true, true],
      },
    ],
  },
  {
    label: "Протоколы передачи данных",
    items: [
      {
        label: "МЭК 61850 Клиент",
        description: "Подключение устройств по МЭК 61850",
        values: [true, true, true],
      },
      {
        label: "МЭК 61850 Сервер",
        description: "Передача данных МЭК 61850-90-2",
        values: [true, true, true],
      },
      {
        label: "МЭК 60870-5-104 Сервер",
        description: "Передача данных МЭК 60870-5-104",
        values: [true, true, true],
      },
      {
        label: "MQTT Клиент",
        description:
          "Возможность приема/передачи данных в брокеры сообщений MQTT",
        values: [true, false, false],
      },
      {
        label: "RabbitMQ Клиент",
        description:
          "Возможность приема/передачи данных в брокер сообщений, который поддерживает множество протоколов (включая AMQP, MQTT , STOMP, HTTP и др.)",
        values: [true, false, false],
      },
      {
        label: "Kafka Клиент",
        description:
          "Возможность приема/передачи данных в брокеры сообщений Kafka",
        values: [true, false, false],
      },
      {
        label: "SNMP Клиент",
        description: "Сбор данных мониторинга сетевых устройств",
        values: [false, true, true],
      },
      {
        label: "SMTP Клиент",
        description: "Возможность отправки уведомлений, оповещений и отчетов по электронной почте",
        values: [true, true, true],
      },
      {
        label: <><Link to={'/sksu'}>СКСУ</Link> клиент</>,
        description: "Взаимодействие SCADA NPT и ПО СКСУ",
        values: [false, true, true],
      },

      {
        label: "OPC UA Client",
        description: "Подключение к OPC UA Server с помощью стандартного протокола OPC UA",
        values: [true, true, true],
      },
      {
        label: "OPC UA Server",
        description: "Источник данных для других устройств и систем, предоставляемых по правилам OPC UA",
        values: [true, true, true],
      },
    ],
  },
  {
    label: "Графические плагины",
    items: [
      {
        label: "Просмотровщик осциллограмм",
        description: "Просмотр и анализ  осциллограм",
        values: [false, true, true],
      },
      {
        label: "Интерактивная географическая карта",
        description: "Интеграция с ГИС",
        values: [false, false, true],
      },

      {
        label: "Video Plugin",
        description: "Отображение информации с видеокамер",
        values: [false, false, true],
      },
    ],
  },
  {
    label: "Опции для электроэнергетики на базе CIM",
    link: { title: "NPT Platform", href: "https://npt-platform.ru/" },
    items: [
      {
        label: "Topology service",
        description: "Топологический анализ",
        values: [false, false, true],
      },
      {
        label: "Powerflow service",
        description: "Расчет режима",
        values: [false, false, true],
      },

      {
        label: "State estimation service",
        description: "Оценивание состояния",
        values: [false, false, true],
      },
      {
        label: "Short circuit service",
        description: "Расчет ТКЗ",
        values: [false, false, true],
      },
      {
        label: "Dispatcher simulator",
        description: "Тренажер диспетчера",
        values: [false, false, true],
      },
      {
        label: "Switching plan",
        description: "Динамический бланк переключений",
        values: [false, false, true],
      },
    ],
  },
  {
    label: "Интегрированная среда параметрирования",
    link: { title: "SCADA Studio", href: `https://scada-npt-expert.ru/scadastudio/` },
    items: [
      {
        label: "Поддержка проекта в виде SCD файла",
        values: [null, true, true],
      },
      {
        label: "Интеграция контроллеров присоединения NPT",
        values: [null, true, true],
      },

      {
        label: "Интеграция СКСУ",
        values: [null, true, true],
      },
      {
        label: "Поддержка логики на всех языках МЭК 61131",
        values: [null, true, true],
      },
    ],
  },
];

export const PRODUCTS = [
  "SCADA NPT Compact",
  "SCADA NPT Expert",
  "SCADA NPT Expert Plus",
];
